import React from 'react';
import { extractChunkNameFromError } from 'utility/utility';

const lazyWithRetries = <T extends React.ComponentType<any>>(
  importer: () => Promise<{ default: T }>,
  chunkName?: string,
): React.LazyExoticComponent<T> => {
  const logChunkLoadError = (error: any, attempt: number, maxAttempts: number) => {
    const finalChunkName = chunkName ?? extractChunkNameFromError(error);

    // eslint-disable-next-line no-console
    console.error('Chunk Load Error Details:', {
      chunkName: finalChunkName,
      attempt: attempt + 1,
      maxAttempts,
      errorMessage: error?.message ?? 'Unknown error',
    });
  };

  const retryImport = async (): Promise<{ default: T }> => {
    try {
      return await importer();
    } catch (error: any) {
      logChunkLoadError(error, 0, 3);

      const retry = async (attempt: number): Promise<any> => {
        if (attempt >= 3) {
          logChunkLoadError(error, attempt, 3);
          throw error;
        }
        await new Promise((resolve) => setTimeout(resolve, 2000));

        try {
          return await importer();
        } catch (e) {
          logChunkLoadError(e, attempt, 3);
          return retry(attempt + 1);
        }
      };
      return retry(0);
    }
  };
  return React.lazy(retryImport);
};

export default lazyWithRetries;
